export default __webpack_public_path__ + "static/media/potilasohjeet-lightblue.4810fd23.svg";